export class ExportData {
  constructor(id, created, type, model, description, title, tablerExport) {
    this.id = id;
    this.created = created;
    this.type = type;
    this.model = model;
    this.description = description;
    this.title = title;
    this.tablerExport = tablerExport;
  }
}
export class ExportDataProjection {
  constructor(id, title, srid) {
    this.id = id;
    this.title = title;
    this.srid = srid;
  }
}